/**
 * Utility functions for processing class names
 */

/**
 * Clean a class name by removing leading numbers and underscores
 * Examples:
 * "01 Love Gold Bracelet" -> "Love Gold Bracelet"
 * "01_love_gold_bracelet" -> "love gold bracelet"
 * "Love Gold Bracelet" -> "Love Gold Bracelet"
 */
export const cleanClassName = (className: string): string => {
  if (!className) return className

  // Remove leading pattern like "01 ", "01_", "02 ", etc.
  const cleaned = className.replace(/^\d+[\s_]+/, '')
  
  // Replace underscores with spaces and title case if it looks like a snake_case string
  if (cleaned.includes('_') && !cleaned.includes(' ')) {
    return cleaned
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ')
  }
  
  return cleaned
}

/**
 * Format a class name for display - handles both folder names and display names
 */
export const formatClassNameForDisplay = (className: string): string => {
  return cleanClassName(className)
}